import React, {useState, useEffect} from "react";
import { useForm, Controller, control, NavLink } from "react-hook-form";
import axios from "axios";
import { DataGrid , GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";
import Select, { StylesConfig }  from "react-select";
import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { theme, Badge, } from "@material-ui/core";
import  HomeOutlinedIcon  from "@mui/icons-material/HomeOutlined";
import chroma from 'chroma-js';
import Header from "../../components/Header.jsx";
import { DatePicker, Space } from 'antd';
import TableXDataGrid from "./TableXDataGrid.jsx";
import { ColorModeContext } from "../../theme.js";
//
import urls from '../../constants/urls.js';

const StyledSelect= styled(Select)({
    fontSize: "14px",
  width: "100%",
  height: "95%",
  marginTop: "2px",
  marginBottom: "2px"
});


const TXTRoundedDiv= styled("div")(({theme})=>({
    borderRadius: theme.shape.borderRadius,
    border: "1px solid #6BD5C0",
    //border: "#65BDC0",
    width: "100%",
    //height: "100%",
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "10px",

}));

const TXTRoundedDivEXT= styled("div")(({theme})=>({
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #6BD5C0",
  //border: "#65BDC0",
  width: "90%",
  //height: "100%",
  marginTop: "1px",
  marginBottom: "1px",
  marginLeft: "1px",
  height: "40px"

}));

const StyledInputEXT= styled(Input)(({theme})=>({
  fontSize: "16px",
  width: "100%",
  height: "41px",
  marginTop: "3px",
  marginBottom: "1px",
  borderRadius: theme.shape.borderRadius,
  border: "1px solid #6BD5C0",

}));

const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

const StyledInput= styled(Input)({
  fontSize: "14px",
  width: "100%",
  height: "90%",
  marginTop: "1px",
  marginBottom: "1px"

});
 
export default function SubClassExamsReportsTopLevel( { schoolsEXT, usersId }) {
    //alert(schoolsEXT)
    const [APIROOTURL, setAPIROOTURL]=useState(urls.rootAPIURL);
    
    const [schoolsAllEXT, setSchoolsAllEXT]=useState(schoolsEXT)

    const [changeToLoad, setChangeToLoad ]=useState(false)
    
    const [reportTypeHead, setReportTypeHead]=useState('');
    
    const [allSchools, setAllSchools]=useState([])

    const [reports, setReports]=useState(0);
   
    const [reportType, setReportType]=useState([
      {id: 0, value: 'Select report type', label: 'Select report type',  name: 'report_type'},
      {id: 1, value: 'All students in a stream report', label: 'All students in a stream report',  name: 'report_type'},
      /** *
      {id: 2, value: 'All students in a class report', label: 'All students in a class report',  name: 'report_type'},
      ***/
      {id: 3, value: 'Single student report', label: 'Single student report',  name: 'report_type'},
      
      {id: 5, value: 'All exams report', label: 'All exams report',  name: 'report_type'},
      
    ])
    
    const [schoolIdGlobal, setSchoolIdGlobal] =useState(0);
    
    const [examsId, setExamsId] =useState(0);

    const [examsHead, setExamsHead]=useState('');
    
    const [subClassHead, setSubClassHead]=useState('');

    const [academicYearHead, setAcademicYearHead]=useState('');

    const [studentHead, setStudentHead]=useState('');
    
    
    const [subClassId, setSubClassId] =useState(0);
    
    const [loadChange, setLoadChange]=useState(false);

    const [academicYearId, setAcademicYearId] =useState(0);
    
    const [buttonForLoadingExamSubjects, setButtonForLoadingExamSubjects]=useState(false)
   
    const [buttonForLoadingExamSubClass, setButtonForLoadingExamSubClass]=useState(false)

    const [buttonForLoadingAcademicYears, setButtonForLoadingAcademicYears]=useState(false)
    
    const [examSubjects, setExamSubjects]=useState([]);

    const [examSubClass, setExamSubClass]=useState([]);
    
    const [exams, setExams]=useState([]);
    
    const [students, setStudents ]=useState([]);

    const [columns, setColumns]=useState([]);
   
    const [classLevels, setClassLevels]=useState([]);
    
    const [ReportTitle, setReportTitle]=useState('');

    const [academicYears, setAcademicYears]=useState([]);

    const [academicYear, setAcademicYear]=useState(0);
    const [classLevelsEXT, setClassLevelsEXT ]=useState(0);

    const [subClass, setSubClass]=useState('');
    const [student, setStudent ]=useState(0);
    
    const [schoolStudentsScores, setSchoolStudentsScores]=useState([]);

    const [formDataSchoolClassEXT, setFormDataSchoolClassEXT]=useState({
         
          id: 0,
          school_student: 0,
          exams_subject: 0,
          exams: 0,
          score: 0,
          status: 'Active',
          /*** 
           id = models.BigAutoField(primary_key=True)
    exams=models.ForeignKey(exams, on_delete=models.CASCADE)
    exams_subject=models.ForeignKey(exams_subject, on_delete=models.CASCADE)
    school_student=models.ForeignKey(school_student, on_delete=models.CASCADE)
    score=models.DecimalField(max_digits=4, decimal_places=1)
    status=models.CharField(max_length=16)
    
           * ***/
      })
      
      /***
     
    date_of_birth=models.DateTimeField(max_length=32, null=True)
    school_name= models.CharField(max_length=64)
       * ***/
    const [errors, setErrors]=useState({});
  
  
   
    const colourStyles = {
      control: styles => ({ ...styles, backgroundColor: "white" }),
      option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        const color = chroma(ColorModeContext.color)
        return {
          ...styles,
          backgroundColor: isDisabled
            ? undefined
            : isSelected
            ? data.color
            : isFocused
            ? color.alpha(0.1).css()
            : undefined,
          color: isDisabled
            ? "#ccc"
            : isSelected
            ? chroma.contrast(color, "white") > 2
              ? "white"
              : "black"
            : data.color,
          cursor: isDisabled ? "not-allowed" : "default",
    
          ":active": {
            ...styles[":active"],
            backgroundColor: !isDisabled
              ? isSelected
                ? data.color
                : color.alpha(0.3).css()
              : undefined
          }
        }
      },
      input: styles => ({ ...styles, ...dot() }),
      placeholder: styles => ({ ...styles, ...dot("#ccc") }),
      singleValue: (styles, { data }) => ({ ...styles, ...dot(data.color) })
    }
    
    //
    const dot = (color = 'transparent') => ({
      alignItems: 'center',
      display: 'flex',
    
      ':before': {
        backgroundColor: color,
        borderRadius: 10,
        content: '" "',
        display: 'block',
        marginRight: 8,
        height: 10,
        width: 10,
      },
    });

    
    const customStyles = {
        option: (base, { data, isDisabled, isFocused, isSelected }) => {
        return {
        ...base,
        backgroundColor: isFocused ? "#6BD5C0" : "#03735D",
        };
    }
    };
    //
    const [submitClicked, changeSubmitClicked]=useState(false);
    const [txtFullName, changeTxtFullName]=useState('');
    const [txtFullNameSimilar, changeTxtFullNameSimilar]=useState(' ');
    
    //
     const tableXDataGridColumns =[
        {
          field: 'users_id',
          headerName: 'ID',
          flex: 1,
          cellClassName: 'name-column--cell',
          type: 'number',
          align: 'left'
      },
      {
        field: 'first_name',
        headerName: 'First Name',
        flex: 1,
        cellClassName: 'name-column--cell',
        type: 'string',
        align: 'center'
      },
    {
      field: 'middle_name',
      headerName: 'Middle Name',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
  },
  {
    field: 'last_name',
    headerName: 'Last Name',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
  },
  {
  field: 'mobile_number',
  headerName: 'Telephone',
  flex: 1,
  cellClassName: 'name-column--cell',
  type: 'string',
  align: 'left'
  },
    {
    field: 'user_email',
    headerName: 'Email',
    flex: 1,
    cellClassName: 'name-column--cell',
    type: 'string',
    align: 'left'
    },

    {
      field: 'gender',
      headerName: 'Gender',
      flex: 1,
      cellClassName: 'name-column--cell',
      type: 'string',
      align: 'left'
      },
     ]
    //
    const onChangeDate = (date, dateString) => {
  
      console.log("date=" + date);
      console.log("dateString=" + dateString);
      console.log(date, dateString);
      setStudentDOB(dateString);
      setFormDataSchoolClassEXT({...formDataSchoolClassEXT, date_of_birth: dateString})
      console.log("studentDOB=" + studentDOB);
  };
    //
    const validateString=(stringValue, similarStringValue)=>{
      let validateString=false
      if(stringValue==="" || stringValue==similarStringValue){
        validateString=true
      }
    }

    function validateOnSubmit(){
          let validateOnSubmitStatus=false;
          validateString=(txtFullName, txtFullNameSimilar)
          
          return validateOnSubmitStatus
    }
    //
    const [firstName, setFirstName] = useState('');
    
  

    
    //
    const onSubmit = (data) => { 
      //alert("");
      //console.log(event.target[0].value)
      console.log(data['txtFirstName']);
    
      return;
      //alert("form=" + form[0]);
      //inputProps
      changeSubmitClicked(true);
      let validateStatus=validateOnSubmit();
      console.log("data=" + data)
      console.log("dt__=" + JSON.stringify(data))
      console.log("validateStatus=" + validateStatus)
      if (validateStatus==true){
        console.log("error=" + true)
        return;
      }
      return;
      const jsonObj=data;
      const myobj={
            first_name: jsonObj['txtFirstName'],
            middle_name: jsonObj['txtMiddleName'],
            last_name: jsonObj['txtLastName'],
            telephone: jsonObj['txtMobileNo'],
            nationality: "TZ",
            gender: patientGender['value'],
            dob: studentDOB + ' 00:00:00.00000',
            status: jsonObj['paymentMethod'],
            age: jsonObj['txtAge'],
            address: jsonObj['txtFirstName'],
            patient_code: "ABCDEFG",
            //status: jsonObj['payment_method']
      }
      const APIURL="/myapi/crnewpatient";
      const bodyJSON=JSON.stringify(data);
      const requestOptions ={
        method: 'POST',
        headers: { 'Content-Type':'application/json' },
        body: JSON.stringify(myobj),
      };
     // return;
      try {
               console.log("bb=" + requestOptions);
               fetch(APIURL, requestOptions)
               .then( (response) =>  response.json())
               .then( (data) => console.log(data))
               .then( (data) => alert(data))
          }
     catch(err) {
     console.log(err.message);
       }
    }
     
    const insuranceCategoryValues=[
      { value: 'Select Insurance Category', label: 'Select Insurance Category' },
      { value: 'NHIF', label: 'NHIF' },
      { value: 'ABC', label: 'ABC' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const genderValues=[
      { value: 'Select gender', label: 'Select gender' },
      { value: 'Male', label: 'Male' },
      { value: 'Female', label: 'Female' },
      //'Male', 'Female' placeholder="Select Insurance Category"
    ]
    
    
    const onOptionChangeHandler = (event) => {
      console.log("User Selected Value - ", event.target.value);
    }
    
    const [patientGender, setPatientGender]=useState(
        [
        {label :'Select gender', value:'Select gender', name: 'gender' },
        {label :'Male', value:'Male', name: 'gender' },
        {label :'Female', value:'Female', name: 'gender' },
        ]
    );
    //console.log(watch("example")) // watch input value by passing the name of it

    const [studentDOB, setStudentDOB]=useState('');
    
    const findGender = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setPatientGender(event);
    }
    

    const [insuranceCategory, setInsuranceCategory]=useState(
      { value: 'Select Insurance Category', label: 'Select Insurance Category' }
      );
    //console.log(watch("example")) // watch input value by passing the name of it

    const findInsuranceCategory = (event) => {
      //console.log("e0=" + event[0].value);
      console.log("e=" + event);
      setInsuranceCategory(event);
    }

    

    {/**
    const StyledInput= styled(Input)({
      width: "100%",
      fontSize: "14px",
      fontColor: "black",
      height: "95%",
      marginBottom: "2px",
      marginTop: "2px",
    })
  **/}
    
    

   
    {/**
    const TXTRoundedDiv = styled("div")(({ theme }) => ({
      backgroundColor: "grey",
      borderRadius: theme.shape.borderRadius,
      width: "100%",
      fontSize: "14px",
      marginBottom: "10px"
    }));
  **/}
   
    const node = document.querySelector("#app");

    const changeDate = (jsDate, dateString) => {
      // ...
    };
    
    const [patientsRecordsUrl, setPatientsRecordsUrl]=useState('SchoolClasssViewEXT');
    //const [studentDOB,]
    const onChangeDOB = (date, dateString) => {
      console.log(date, dateString)
      setStudentDOB(dateString)
      console.log("pdob=" + studentDOB)
    };
    

    /***
    ***/
    /** **/
    const myBox=()=> {
      return <div className="box"> ABC </div>;
      {/**{showRecords ? <myBox /> : <PRFHooks/>}**/}
    }
    const tOPButtonOnClick = () =>{
       if(showForm==true){
        setShowForm(false)
        setTopButtonLabel('Show Form')
       }
       else{
        setShowForm(true)
        setTopButtonLabel('Show Records')
       }
    }
    const [showForm, setShowForm] = useState(true);
    const [topButtonLabel, setTopButtonLabel]=useState('Show Records');
    
    function changeFirstName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setFirstName(e ? e: "");
    }

    const[middleName, setMiddleName]=useState('');

    function changeMiddleName(e){
      // setFirstName(e);
      console.log("eeh=" + e);
      setMiddleName(e ? e: "");
    }

    function handleFirstNameChange(e){
       //console.log("et=" + e.value);
       console.log("e=" + e.target.value);
       try{
        var ee=e.target.value;
       
       }
       catch(Exception){
        console.log("error=" + Exception);
       }
       console.log("fn=" + firstName);
       console.log("ee=" + ee);
       
       //props.value ? props.value : ""
      // e.target.value ? changeFirstName(e.target.value) : ""
       //changeFirstName(ee);
       console.log("fn1=" + firstName);
       
      }
      

      const [fName, setFName]=useState("f name");

      const handleChangeInput = (e) =>{
        const {name, value } =e.target
        setFormDataSchoolClassEXT({
         ...formDataSchoolClassEXT,
         [name]: value
        })
        //
        
        //
        setErrors({});
      }
     
      
  const handleChangeSelect = (e) =>{
    const {name, value } = e
    
    let textstr='';
    //console.log("e.target.name=" + e.target.name) handleChangeSelect
    console.log("name=" + name +  ", value=" + value)
    
    if(name==="report_type"){
      
      setReports(e.id)
      setReportTypeHead(e.value)
      setReportTitle(e.value + ' ')

      if(e.id===3 || e.id==3){
        setChangeToLoad(!changeToLoad)
      }
      else{

      }
      //setChangeToLoad(!changeToLoad)
  }


  if(name==="class_levels"){
   /*** *
    setFormDataSchoolClassEXT({
      ...formDataSchoolClassEXT,
      class_levels: e.id
    })
    ***/
    setClassLevelsEXT(e.id);
    setLoadChange(!loadChange)
}


  if(name==="student"){
      
    setStudent(e.id);
    setChangeToLoad(!changeToLoad);
    
    if(e.id>0){
      textstr=ReportTitle;
      setReportTitle( textstr + ' for student ' + e.value + ' ')
    }
    //setChangeToLoad(!changeToLoad)
   }

    if(name==="school_student"){
        setFormDataSchoolClassEXT({
        ...formDataSchoolClassEXT,
        school_student: e.id
        })

        textstr=ReportTitle;
        setReportTitle( textstr + ' for student ' + e.value + ' ')

        setChangeToLoad(!changeToLoad)
    }

   if(name==="exams_subject"){
    setFormDataSchoolClassEXT({
        ...formDataSchoolClassEXT,
        exams_subject: e.id
        })
        setButtonForLoadingExamSubClass(!buttonForLoadingExamSubClass)
        //setChangeToLoad(!changeToLoad)
        setChangeToLoad(!changeToLoad)
    }

    if(name==="exams"){
            setFormDataSchoolClassEXT({
              ...formDataSchoolClassEXT,
              exams: e.id
              })
              
              setExamsId(e.id)
              
              setButtonForLoadingExamSubjects(!buttonForLoadingExamSubjects)
              setButtonForLoadingExamSubClass(!buttonForLoadingExamSubClass)
              
              textstr=ReportTitle;
              setReportTitle( textstr + ' for exam ' + e.value + ' ')
             // setChangeToLoad(!changeToLoad)
             setChangeToLoad(!changeToLoad)
    }
    
    if(name==="sub_class"){
       setSubClass(e.id)
       //setExamsId(e.id)
        //setButtonForLoadingExamSubjects(!buttonForLoadingExamSubjects)
       // setChangeToLoad(!changeToLoad)
       setSubClassId(e.id)

       textstr=ReportTitle;
       setReportTitle( textstr + ' for stream ' + e.value + ' ')
       
       setChangeToLoad(!changeToLoad)
   }

   if(name==="academic_year"){
     setAcademicYear(e.id)
     setAcademicYearId(e.id)
     //setButtonForLoadingAcademicYears(!buttonForLoadingAcademicYears)
    // setChangeToLoad(!changeToLoad)
      //setButtonForLoadingExamSubjects(!buttonForLoadingExamSubjects)
      textstr=ReportTitle;
      setReportTitle( textstr + ' for academic year ' + e.value + ' ')
      setChangeToLoad(!changeToLoad)
    }

    if(name==="school"){
      setSchoolIdGlobal(e.id)
      //setAcademicYearId(e.id)
      
      // textstr=ReportTitle;
      // setReportTitle( textstr + ' for academic year ' + e.value + ' ')
       setChangeToLoad(!changeToLoad)
       setButtonForLoadingExamSubjects(!buttonForLoadingExamSubjects)
     }

   setErrors({});
    
  }

  
  
  
  const loadExamSubClass=(data)=>{
    setExamSubClass([])
    let newList=[];

    newList.push({ id: 0, label: 'Select stream', value: 'Select stream', name: 'sub_class'})
    {
        data.map(function(dt){
          let xx=0;         
          
          newList.push({id: dt.sub_class_id, label: dt.subclass_name, value: dt.subclass_name , name: 'sub_class'})
          
         // newList.push({id: dt.school_sub_class_id, label: dt.stream_name, value: dt.stream_name , name: 'sub_class'})
        
        }
      )
    }
    
    //
    
    setExamSubClass(newList)

  }

  
  useEffect(()=>{
    //alert(schoolIdGlobal + "," + usersId)
   
  let APIURL= APIROOTURL + "SingleSchoolSubClassViewEXT/" + schoolIdGlobal
  let headerOptions={
      method: 'GET',
  }
  
  console.log("trying API VIEW " + APIROOTURL  + "SingleSchoolSubClassViewEXT/" + schoolIdGlobal)

  fetch(APIURL, headerOptions)
  .then( response => response.json())
  .then( json =>{
   console.log("json 123 =" + json);
   console.log("json 5123 =" + json[0]['name']);
   console.log("json 123 =" + json[0].name);
   loadExamSubClass(json)
  })
  .catch(error=> console.log("error=" + error))
  
  },[buttonForLoadingExamSubClass])


  
  useEffect(()=>{
    //alert(schoolIdGlobal + "," + usersId)
    let xList=[]

    schoolsAllEXT.map( function(dt){
      
      xList.push({
        id: dt.schoolId, label: dt.schoolName, value: dt.schoolName , name: 'school'
      })
          
    })

    setAllSchools(xList)
    
  },[])


 
  const loadAcademicYears=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select academic year', value: 'Select academic year', name: 'academic_year'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'academic_year'})
          console.log("dt.name=" + dt.name)
        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setAcademicYears(newList)
  }
  


  
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "AcademicYearViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadAcademicYears(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])


    
  
  const loadClassLevels=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select class level', value: 'Select class level', name: 'class_levels'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'class_levels'})
          console.log("dt.name=" + dt.name)
        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setClassLevels(newList)
  }
  
  
  
      
  useEffect(()=>{
      
    let APIURL= APIROOTURL + "ClassLevelsViewEXT"
    let headerOptions={
        method: 'GET',
    }

    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadClassLevels(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[])



  

    const loadExamColumns=(data)=>{
      let newList=[]
      
      //alert("D reports=" + "'" + reports + "'")
       
      if(reports===1 || reports==1){

       

      newList.push({
        field: "id", 
        headerName: 'ID' ,
        flex:1,
         })

         newList.push({
          field: "studentName", 
          headerName: 'Student name' ,
          flex:2,
           })

      {
          data.map(function(dt){
            newList.push(
              {
              
              field: dt.subject_name, 
              headerName: dt.subject_name ,
              flex:1,
            }
          )
            //console.log("dt.name=" + dt.name)
          })
      }

      newList.push({
        field: "totalScore", 
        headerName: 'Total' ,
        flex:1,
         })

         newList.push({
          field: "averageScore", 
          headerName: 'Average' ,
          flex:1,
           })
     
        }

        else if(reports===3 || reports==3 || reports==="3"){
          //alert("E")
          
          newList.push(
            
            {
              field: "id", 
              headerName: 'ID' ,
              flex:0.5,
            },

            {
              field: "subject", 
              headerName: 'SUBJECT' ,
              flex:1.5,
            },

            {
              field: "score", 
              headerName: 'SCORE' ,
              flex:1,
            },

            {
              field: "grade", 
              headerName: 'GRADE' ,
              flex:1,
            },

            {
              field: "divisionPoints", 
              headerName: 'DIV POINTS' ,
              flex:1,
            },

            {
              field: "gpaPoints", 
              headerName: 'GPA POINTS' ,
              flex:1,
            },

            {
              field: "remarks", 
              headerName: 'REMARKS' ,
              flex:2,
            },

            {
              field: "position", 
              headerName: 'POSITION' ,
              flex:2,
            },
          
          )
         
        }
         
        else if(reports===5 || reports==5){

       //alert("inside rt=5")

          newList.push({
            field: "id", 
            headerName: 'ID' ,
            flex:1,
             })
    
             newList.push({
              field: "studentName", 
              headerName: 'Student name' ,
              flex:2,
               })
    
          {
              data.map(function(dt){
                newList.push(
                  {
                  
                  field: dt.subject_name, 
                  headerName: dt.subject_name ,
                  flex:1,
                }
              )
                //console.log("dt.name=" + dt.name)
              })
          }
    
          newList.push({
            field: "totalScore", 
            headerName: 'Total' ,
            flex:1,
             })
    
             newList.push({
              field: "averageScore", 
              headerName: 'Average' ,
              flex:1,
               })
         
            }

            
          else{

          }

      setColumns(newList)
    }
    


  useEffect(()=>{
    
    //alert("B reports=" + reports)

    let APIURL=""
    let headerOptions={
      method: 'GET',
     }
    //snoop
    //alert("A reports=" + reports)

    if(reports===1 || reports==1){

      
    APIURL= APIROOTURL + "SubClassFullExamColumnsViewEXT/" + examsId + "/" + subClassId
    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadExamColumns(json)
    })
    .catch(error=> console.log("error=" + error))
    

    }
    else if(reports===3 || reports==3){
      
     // alert("C")
      let data=[];
      loadExamColumns(data)
    }

    else if(reports===5 || reports==5){
      
      APIURL= APIROOTURL + "SubClassAllExamsColumnsViewEXT/" + academicYear + "/" + subClassId
    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadExamColumns(json)
    })
    .catch(error=> console.log("error=" + error))
    
     }
    else{

    }
   
    },[changeToLoad])


  

  const loadExamSubjects=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select subject', value: 'Select subject', name: 'exams_subject'})
    {
        data.map(function(dt){
          newList.push({id: dt.subject_id, label: dt.subject_name, value: dt.subject_name , name: 'exams_subject'})
        })
    }

    setExamSubjects(newList)
  }
  
  useEffect(()=>{
    //alert(schoolIdGlobal + "," + usersId)
  let APIURL= APIROOTURL + "OnlyExamSubjectsViewEXT/" + schoolIdGlobal + "/" + formDataSchoolClassEXT['exams']
  let headerOptions={
      method: 'GET',
  }
  
  fetch(APIURL, headerOptions)
  .then( response => response.json())
  .then( json =>{
   console.log("json 123 =" + json);
   console.log("json 5123 =" + json[0]['name']);
   console.log("json 123 =" + json[0].name);
   loadExamSubjects(json)
  })
  .catch(error=> console.log("error=" + error))
  
  },[buttonForLoadingExamSubjects])

  
  /*** *
  const loadAcademicYears=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select academic year', value: 'Select academic year', name: 'academic_year'})
    {
        data.map(function(dt){
          newList.push({id: dt.id, label: dt.name, value: dt.name , name: 'academic_year'})
          console.log("dt.name=" + dt.name)
        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setAcademicYears(newList)
  }
  ***/

  const loadStudentsScores=(data)=>{
    let newList=[]
    let xdict={}
    //alert("start")
    if(reports===1 || reports==1){
    {
        data.map(function(dt, index){
          let aa=index+1 
          xdict={}
          //snoop
            
            console.log("3 xcv xdict=" + dt)
            let dtt=JSON.parse(dt)
            newList.push(dtt)
        })
    }

  }
  
  else if(reports===3 || reports==3){
    //alert("inside")
    {
      data.map(function(dt, index){
       
        newList.push(
          //yamal
          
          {
            id: dt.id, 
            subject: dt.subject,
            score: dt.score,
            grade: dt.grade,
            remarks: dt.remarks,
            divisionPoints: dt.divisionPoints,
            gpaPoints: dt.gpaPoints,
            position: dt.position
          }
        )
        console.log("grade=" + dt.grade)
      })
    }

  }

  else if(reports===5 || reports==5){
    {
        data.map(function(dt, index){
          let aa=index+1 
          xdict={}
          //snoop
            
            console.log("3 xcv xdict=" + dt)
            let dtt=JSON.parse(dt)
            newList.push(dtt)
        })
    }

  }
  else{


  }
    //setSchoolStudentsScores
    setSchoolStudentsScores(newList)
  }



  const loadSchoolExams=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select exams', value: 'Select exams', name: 'exams'})
    {   
        data.map(function(dt){
          let x=0
          //if(x===0){
          newList.push({id: dt.exams_id, label: dt.exams_name, value: dt.exams_name , name: 'exams'})
          //console.log("dt.name=" + dt.name)
           //}

        })
    }
   
    console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setExams(newList)
  }
  

     
  useEffect(()=>{
      //alert(schoolIdGlobal + "," + usersId)
    let APIURL= APIROOTURL + "SingleSchoolExamsUsingSchoolIdViewEXT/" + schoolIdGlobal + "/" + academicYearId + "/" + classLevelsEXT
    let headerOptions={
        method: 'GET',
    }
    
    fetch(APIURL, headerOptions)
    .then( response => response.json())
    .then( json =>{
     console.log("json 123 =" + json);
     console.log("json 5123 =" + json[0]['name']);
     console.log("json 123 =" + json[0].name);
     loadSchoolExams(json)
    })
    .catch(error=> console.log("error=" + error))
    
    },[changeToLoad])
    //SingleSchoolExamsUsingSchoolIdView

  

  

    
  const loadSubClassStudentsExams=(data)=>{
    let newList=[]
    newList.push({ id: 0, label: 'Select student', value: 'Select student', name: 'student'})
    {   
        data.map(function(dt){
          let x=0
          //if(x===0){
          newList.push({id: dt.student_id, label: dt.full_name, value: dt.full_name , name: 'student'})
          //console.log("dt.name=" + dt.name)
           //}

        })
    }
   
    //console.log("newList newList[0]['value'] =" + newList[0]['value'] + ", newList newList[1]['value'] =" + newList[1]['value'])
    
    setStudents(newList)
  }
  
      
  useEffect(()=>{
    //alert(schoolIdGlobal + "," + usersId)
  let APIURL= APIROOTURL + "SubClassStudentsUsingSubClassAndAcademicYearViewEXT/" + schoolIdGlobal + "/" + subClass + "/" + academicYear + ""
  let headerOptions={
      method: 'GET',
  }
  
  fetch(APIURL, headerOptions)
  .then( response => response.json())
  .then( json =>{
   console.log("json 123 =" + json);
   console.log("json 5123 =" + json[0]['name']);
   console.log("json 123 =" + json[0].name);
   loadSubClassStudentsExams(json)
  })
  .catch(error=> console.log("error=" + error))
  
  },[changeToLoad])


  

  /*** *
    
   ***/


    useEffect(()=>{
      let APIURL=""
      
      let headerOptions={
        method: 'GET',
    }
      //neyo

        if(reports===1 || reports==1){
          APIURL= APIROOTURL + "SubClassFullExamResultsViewEXT/" + schoolIdGlobal + "/" + examsId + "/" + subClass + "/" + academicYear
          
          
        
        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json =>{
         console.log("fire json=" + json);
         loadStudentsScores(json)
        })
        .catch(error=> console.log("error=" + error))
        
        }

        else  if(reports===3 || reports==3){
          
          APIURL= APIROOTURL + "SingleStudentFullExamResultsViewEXT/" + schoolIdGlobal + "/" + examsId + "/" + subClass + "/" + academicYear + "/" + student
          
          
        
        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json =>{
         console.log("fire json=" + json);
         loadStudentsScores(json)
        })
        .catch(error=> console.log("error=" + error))
        
        }

        else if( reports===5 || reports==5){
          
          APIURL= APIROOTURL + "SubClassAllExamsResultsViewEXT/" + schoolIdGlobal + "/" + subClass + "/" + academicYearId
          
        
        fetch(APIURL, headerOptions)
        .then( response => response.json())
        .then( json =>{
         console.log("fire json=" + json);
         loadStudentsScores(json)
        })
        .catch(error=> console.log("error=" + error))
        
        }

        else{

        }

       
        
        },[changeToLoad])


        {/*** *
        useEffect(()=>{
      
            let APIURL= APIROOTURL + "AllStudentsViewEXT"
            let headerOptions={
                method: 'GET',
            }
        
            fetch(APIURL, headerOptions)
            .then( response => response.json())
            .then( json =>{
             console.log("json=" + json);
             loadStudentsScores(json)
            })
            .catch(error=> console.log("error=" + error))
            
            },[])
           ***/}
      
const validateForm = (data) =>{
    const errors={};
    
    /***
          school_student: 0,
          exams_subject: 0,
          exams: 0,
          score: 0,
          status: 'Active',
    ***/
    if(data.exams==="0" || data.exams=="0" || data.exams===0 || data.exams==0){
           // console.log("if " + ", class name, data.student=" + data.exams_subject)
            errors.exams='Please select exam';
    }

    if(data.score==="" || data.score=="" || data.score===0 || data.score==0){
      // console.log("if " + ", class name, data.student=" + data.exams_subject)
       errors.score='Please enter exam score';
       alert("Please enter exam score")
    }

    console.log("01 " + ", data.student=" + data.exams_subject)
    if(data.exams_subject==="0" || data.exams_subject=="0" || data.exams_subject===0 || data.exams_subject==0){
        console.log("if " + ", class name, data.student=" + data.exams_subject)
        errors.exams_subject='Please select exam subject';
    }
    //console.log("01 " + ", data.acade=" + data.student) academic_year
    if(data.school_student==="0" || data.school_student=="0" || data.school_student===0 || data.school_student==0){
        console.log("if " + ", class name, data.school_student=" + data.school_student)
        errors.school_student='Please select student';
    }

    if(data.exams==="0" || data.exams=="0" || data.exams===0 || data.exams==0){
        console.log("if " + ", class name, data.exams=" + data.exams)
        errors.exams='Please select exam';
    }

    if(data.score==="" || data.score=="" || data.score===0 || data.score==0){
        console.log("if " + ", class name, data.exams=" + data.score)
        errors.score='Please select score';
    }
    
    /*** *
   
    ****/
    
   

   
     
     
     /*** *
     if(data.user_password==="" || data.user_password==""){
      console.log("if " + ", data.name=" + data.user_password)
      errors.user_password='Please enter password';
     }
     else{
      console.log("else " + ", data.user_password=" + data.user_password)
     }  ***/
    
    return errors;
  
  }
  

   
    const submitStudentStream=()=>{

        
         let newErrors=validateForm(formDataSchoolClassEXT);
         setErrors(newErrors);
         
         console.log("errors.lenght=" + Object.keys(newErrors).length)
         if(Object.keys(newErrors).length===0){
           console.log("len0")
           CreateStudentExamScore()
         }
         else{
           console.log("len1")
         }
         
    }


    
   const CreateStudentExamScore=(formData)=>{
     
     //CreateStudentExamScore
    //let url = API_URL;      CreateStudentExamScoreViewEXT   CreateStudentInAStreamViewEXT
    let APIURL= APIROOTURL + "CreateStudentExamScoreViewEXT"
    let picsId=0;
    axios
      .post(APIURL, formData, {
        headers: {
          "Content-type": "multipart/form-data",
        },
      })
      .then((res) => {
        console.log("res.data.msg=" + res.data.msg)
        let usersId=res.data.usersId;
       let fullName=res.data.username; //res.data.fullName;
       
       let loginCategoryName=res.data.category;
       let userRolesList=[];//res.data.qr;
      
       let loginDetails=[];//res.data.loginDetails;
     
       let loginDetailsForm={
        loginCategory: loginCategoryName,
        
        userPassword: formDataSchoolClassEXT['user_password'],
        fullName: fullName,
        usersId: usersId,
      }
                        //School Student was successfully created
       if (res.data.msg==="Exam score was successfully created"){
        //
        alert("Exam score was successfully created")
       //  
       }
       else if (res.data.msg==="A user with similar mobile numbers has already been created"){
        //
        alert("A user with similar mobile numbers has already been created")
       //  
       }
       else{
        alert("Creating School class failed");
       }
       //
       
      // setload
      setChangeToLoad(!changeToLoad)
      })
      .finally(() => {
       
    
      })
      .catch((err) => console.log(err));

   }   


   const SaveStudentExamsScore=( examSubjectId, studentId, examsId )=>{
        
        //return;
        setFormDataSchoolClassEXT({ ...formDataSchoolClassEXT, school_student: studentId})
        
        //alert(studentId + "," + formDataSchoolClassEXT['school_student'])

        let formData={
          school_student: studentId,
          exams_subject: formDataSchoolClassEXT['exams_subject'],
          exams: formDataSchoolClassEXT['exams'],
          score: formDataSchoolClassEXT['score'],
          status: 'Active',
        }

       // let newErrors=validateForm(formDataSchoolClassEXT);
       let newErrors=validateForm(formData);
        setErrors(newErrors);
        ///school_student
        console.log("errors.lenght=" + Object.keys(newErrors).length)
        if(Object.keys(newErrors).length===0){
          console.log("len0")
          CreateStudentExamScore(formData)
        }
        else{
          console.log("len1")
        }
    
     
   }
  
   
  
  const columnsz = [
    { 
      field: "id", 
      headerName: "SNo" 
    },
    { 
      field: "full_name", 
      headerName: "Student name" ,
      flex:2,
    },
   
    { 
      field: "score", 
      headerName: "Score" ,
      flex:1,
    },
   
    {
      field: "student_id",
      headerName: "Score",
      flex: 2,

      renderCell: ({ row: { exam_subject_id, student_id, exams_id } }) => {
        return (
          <Box
            width="90%"
            m="0 auto"
            p="1px"
            display="flex"
            justifyContent="center"
            //backgroundColor={}
            borderRadius="4px"
          >
            
           
            <StyledInputEXT
            name="score"
            placeholder="Enter score"
            onChange={handleChangeInput}
           />
            
          </Box>
        );
      },
    },
     
    {
      field: "exam_subject_id",
      headerName: "ADD SCORE",
      flex: 1,
      renderCell: ({ row: { exam_subject_id, student_id, exams_id } }) => {
        return (
          <Box
            width="60%"
            m="0 auto"
            p="5px"
            display="flex"
            justifyContent="center"
            //backgroundColor={}
            borderRadius="4px"
          >
            
            <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', width: '150px', marginTop: '10px'}}
           //                             users_id, first_name, ward_id, district_id,city_id, mobile_number, city_name, middle_name, last_name, full_name, gender, date_of_birth, password_id, user_password, login_category_id, login_category_name, school_id, school_name, user_email
           onClick={()=>SaveStudentExamsScore( exam_subject_id, student_id, exams_id )}
           >
                ADD SCORE
            </Button>
          </Box>
        );
      },
    },
  ];
  
  
  const CustomGridToolbar = () => {
    return (
      <>
      <GridToolbarContainer>
        {/***<center><h3>{ReportTitle}</h3></center>***/}
      </GridToolbarContainer>
      <GridToolbar />
      </>
    )
  }
    
    return (
      <Box m="20px">
      
      {/** <Button>RECORDS</Button> **/}
      {/**
      <Button type="submit" color="secondary" variant="contained"
      onClick={tOPButtonOnClick}
      >
        {topButtonLabel}
      </Button>
    **/}
      <span>
      
      </span>
      
      <br/>
      
     
      
      {showForm && (<div>
      <Header title="STUDENTS EXAM REPORTS" subtitle="Students exam reports" />
      
        
        <Stack direction="row" spacing={1} justifyContent="space-between">

          <StyledBox flex={3}>
        
           
          </StyledBox>
          
          <StyledBox flex={6}>    
           
           {/***
          <TXTRoundedDiv style={{border: '1px solid #6BD5C0'}}>
           <StyledInput 
           name="name"
           onChange={handleChangeInput}
           placeholder="Class Name"
           
            />
           {errors.name && (<span> {errors.name} </span>) }
           </TXTRoundedDiv>
           ***/}
          

          {/*** */}
           <TXTRoundedDiv>
              <Select
                  name="report_type"
                  placeholder="Select report"
                  options={reportType}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.report_type && (<span> {errors.report_type} </span>)}
         </TXTRoundedDiv>

          {/****/}
          
          <TXTRoundedDiv>
              <Select
                  name="school"
                  placeholder="Select school"
                  options={allSchools}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.school && (<span> {errors.school} </span>)}
         </TXTRoundedDiv>
         
          {/****/}


          {/****/}
          
          <TXTRoundedDiv>
              <Select
                  name="class_levels"
                  placeholder="Select class levels"
                  options={classLevels}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.class_levels && (<span> {errors.class_levels} </span>)}
         </TXTRoundedDiv>
         
          {/****/}

        
         
         {/***
         <TXTRoundedDiv>
              <Select
                  name="exams_subject"
                  placeholder="Select exam subject"
                  options={examSubjects}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.exams_subject && (<span> {errors.exams_subject} </span>)}
         </TXTRoundedDiv>
         ***/}
         
          
        
         
          <TXTRoundedDiv>
              <Select
                  name="academic_year"
                  placeholder="Select academic year"
                  options={academicYears}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.academic_year && (<span> {errors.academic_year} </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
              <Select
                  name="exams"
                  placeholder="Select exam"
                  options={exams}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.exams && (<span> {errors.exams} </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
              <Select
                  name="sub_class"
                  placeholder="Select stream"
                  options={examSubClass}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.sub_class && (<span> {errors.sub_class} </span>)}
         </TXTRoundedDiv>

         <TXTRoundedDiv>
              <Select
                  name="student"
                  placeholder="Select student"
                  options={students}
                  styles={customStyles}
                  onChange={handleChangeSelect}
              />
              {errors.student && (<span> {errors.student} </span>)}
         </TXTRoundedDiv>
         
         {/***
         <TXTRoundedDiv>
           <StyledInput 
           name="score"
           onChange={handleChangeInput}
           placeholder="Score"
           
            />
           {errors.score && <span> {errors.score} </span>}
        </TXTRoundedDiv>
            ***/}

           {/***
            
            ***/}
          
           {/*****/}
           <Button 
           type="submit" color="secondary" variant="contained"
           sx={{ marginLeft: '12px', marginBottom: '30px', width: '150px', marginTop: '10px'}}
           onClick={()=>{ setChangeToLoad(!changeToLoad)}}
           >
                LOAD REPORT
            </Button>
           {/*** * ***/}

         <br />
         
         
         
          </StyledBox>
          
          <StyledBox flex={3}>

          </StyledBox>

        </Stack>
        
        <Stack direction="row" spacing={1} justifyContent="space-between">
        <Box display="flex" justifyContent="end" mt="20px">
              
              {/***
              <input 
               type="submit"
               sx={{
                  backgroundColor: "#62529c",
                  border: "none",
                  color: "#fff",
                  padding: "15px 30px",
                  textDecoration: "none",
                  margin: "4px 2px",
                  cursor: "pointer",
               }}
              />
               ***/}
              
             
        </Box>

        </Stack>
        
        
       

      {/***</form> ***/}
      </div>) }
        
        <br />

      <Stack direction="row" spacing={1} justifyContent="space-between">

      <StyledBox flex={0.25}></StyledBox>

        <StyledBox flex={11.5}>
          <div >

         <DataGrid 
         checkboxSelection 
         rows={schoolStudentsScores} 
         columns={columns} 
         /****
         slots={{
           toolbar: GridToolbar,
           
          }} 
        ****/
          slots={{ toolbar: CustomGridToolbar }}
         />

         </div>
         </StyledBox>

         <StyledBox flex={0.25}></StyledBox>
         </Stack> 

      </Box>
      
    )
  }